// import ModalForm from "./Form";
import ClassTableForm from "./ClassTableForm";
import { LEAD } from "../../../../../../../Config/ApiUrl";
import { DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { ClassTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: actions.DATATABLE_DATA,
			// Endpoint: LEAD,
			tableId: "class-table",
			formId: "class-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Invoice Number",
					type: "text",
					key: "phone",
				},
				{
					title: "Class Name",
					type: "text",
					key: "phone",
				},
				{
					title: "Class Type",
					type: "text",
					key: "name",
				},
				{
					title: "Sub Status",
					type: "text",
					key: "status",
				},
				{
					title: "SC",
					type: "text",
					key: "name",
				},
				{
					title: "Main Teacher",
					type: "text",
					key: "name",
				},
				{
					title: "CO Teacher",
					type: "text",
					key: "name",
				},
				{
					title: "Start Date",
					type: "text",
					key: "name",
				},
                {
					title: "End Date",
					type: "text",
					key: "name",
				},
                {
					title: "Attendance",
					type: "text",
					key: "name",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "LogTable",
				url: actions.DATATABLE_DATA,
				// url: LEAD,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "class-table-form",
						modalId: "class-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				// filters: [
				// 	{
				// 		title: this.$t("Task"),
				// 		type: "range-picker",
				// 		key: "date",
				// 		option: ["today", "thisMonth", "last7Days", "nextYear"],
				// 	},
				// 	{
				// 		title: this.$t("age"),
				// 		type: "range-filter",
				// 		key: "age-range",
				// 		maxTitle: this.$t("max_age"),
				// 		minTitle: this.$t("min_age"),
				// 		sign: "",
				// 	},
				// 	{
				// 		title: "Learning Program",
				// 		type: "checkbox",
				// 		key: "status",
				// 		option: [
				// 			{ id: "active", value: "Active" },
				// 			{ id: "inactive", value: "Inactive" },
				// 			{ id: "invited", value: "Invited" },
				// 		],
				// 	},
				// 	{
				// 		title: "Sub Status",
				// 		type: "radio",
				// 		key: "filter-with-gender",
				// 		option: [
				// 			{ id: "male", value: "Male" },
				// 			{ id: "female", value: "Female" },
				// 			{ id: "other", value: "Other" },
				// 		],
				// 		header: {
				// 			title: this.$t("want_to_filter_your_list"),
				// 			description: this.$t(
				// 				"you_can_filter_your_data_table_which_are_created_based_on_gender"
				// 			),
				// 		},
				// 	},
				// 	{
				// 		title: "Residency",
				// 		type: "checkbox",
				// 		key: "status",
				// 		option: [
				// 			{ id: "active2", value: "Active" },
				// 			{ id: "inactive2", value: "Inactive" },
				// 			{ id: "invited2", value: "Invited" },
				// 		],
				// 	},
				// ],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
